import { Box, Typography } from '@mui/material'
import { Grid } from '@mui/system'
import React from 'react'

import { Icon } from '#/components/Icon'
import Palette from '#/styles/Palette'

const SegmentedInfoList = ({ isInfo = false, data }) => {
  if (isInfo) {
    return (
      <Box sx={{ mt: 1 }}>
        {data?.sections?.map(({ title, actions }, sectionIndex) => (
          <Box key={sectionIndex} sx={{ pb: 1 }}>
            <Typography sx={{ fontWeight: 600 }}>{title}</Typography>
            {actions?.map(({ title }, actionKey) => (
              <Box key={actionKey} sx={{ display: 'flex', flexDirection: 'row', pl: 1 }}>
                <Typography>
                  &bull; <span>{title}</span>
                </Typography>
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    )
  }

  return (
    <>
      <Grid sx={{ mb: 3 }}>
        <Typography variant="h6">{data?.title}</Typography>
      </Grid>
      {data?.sections?.map(({ title, actions }, sectionIndex) => (
        <React.Fragment key={sectionIndex}>
          <Typography variant="body1" sx={{ fontWeight: 600, mt: 2, mb: 1 }}>
            {title}
          </Typography>
          {actions.map(({ completed, current, title }, actionKey) => (
            <Box
              key={actionKey}
              sx={{
                display: 'flex',
                gap: 2,
                py: 0.3,
                pl: 1,
                color: current ? Palette.blue.self[500] : Palette.gray.self[800],
              }}
            >
              <Typography>
                {completed ? (
                  <Icon size="large" name="done" />
                ) : (
                  <Icon size="large" name="access-time" />
                )}
              </Typography>
              <Typography>{title}</Typography>
            </Box>
          ))}
        </React.Fragment>
      ))}
    </>
  )
}

export default SegmentedInfoList
